var _effectorFileName = "/builds/gmini/front-chm-api-sdk/src/Template.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { AssigneeSourceIO } from './assigneeSource.enum';
import { ApiDomain } from './domain';
export var Template;
(function (_Template) {
  var domain = ApiDomain.domain('Template', {
    name: "domain",
    sid: "-1o6k30"
  });
  var Question = _Template.Question = t.type({
    id: t.number,
    name: t.string,
    weight: t.number,
    description: t.union([t.string, t["null"]])
  });
  var Section = _Template.Section = t.type({
    id: t.number,
    weight: t.number,
    name: t.string,
    description: t.string,
    items: t.union([t.array(Question), t.undefined])
  });
  var Status = _Template.Status = t.union([t.literal('DRAFT'), t.literal('DONE')]);
  var TemplateType = _Template.TemplateType = t.type({
    id: t.number,
    name: t.string
  });
  var Initiator = _Template.Initiator = t.type({
    id: t.number,
    source: AssigneeSourceIO,
    templateId: t.number,
    initiatorId: t.string
  });
  var AbstractTemplateProperties = _Template.AbstractTemplateProperties = t.type({
    id: t.number,
    version: t.number,
    templateTypeId: t.union([t.number, t["null"]]),
    deleted: t["boolean"],
    description: t.string,
    allowSectionAssignee: t["boolean"],
    name: t.string,
    signatureRequired: t["boolean"],
    createdAt: t.union([t.string, t.undefined]),
    updatedAt: t.union([t.string, t.undefined]),
    projectUrn: t.string,
    ownerId: t.union([t.string, t["null"]]),
    initiators: t.array(Initiator)
  });
  var TemplatePopulated = _Template.TemplatePopulated = t.intersection([AbstractTemplateProperties, t.type({
    type: t.literal('TemplatePopulated'),
    sections: t.array(Section)
  })]);
  var Template = _Template.Template = t.intersection([AbstractTemplateProperties, t.type({
    type: t.literal('Template'),
    sectionsTotal: t.number,
    itemsTotal: t.number,
    instanceTotal: t.number
  })]);
  var Data = _Template.Data = t.type({
    list: t.array(Template),
    total: t.number
  });
  var fetchList = _Template.fetchList = ApiCallService.create({
    name: 'fetchList',
    parentDomain: domain,
    result: Data,
    getKey: ['limit', 'offset', 'projectUrn']
  });
  var FilterInitiator = _Template.FilterInitiator = t.type({
    initiatorId: t.string,
    source: AssigneeSourceIO
  });
  var FetchAllowedFiltersResponse = _Template.FetchAllowedFiltersResponse = t.type({
    ownerIds: t.array(t.string),
    initiators: t.array(FilterInitiator),
    templateTypeIds: t.array(t.number),
    createdDateRange: t.union([t.tuple([t.string, t.string]), t["null"]]),
    updatedDateRange: t.union([t.tuple([t.string, t.string]), t["null"]])
  });
  var fetchAllowedFilters = _Template.fetchAllowedFilters = ApiCallService.create({
    name: 'fetchAllowedFilters',
    parentDomain: domain,
    result: FetchAllowedFiltersResponse,
    getKey: ['projectUrn']
  });
  var fetchTemplate = _Template.fetchTemplate = ApiCallService.create({
    name: 'fetchTemplate',
    parentDomain: domain,
    result: TemplatePopulated,
    getKey: ['id', 'version']
  });
  var fetchTemplateMostRecent = _Template.fetchTemplateMostRecent = ApiCallService.create({
    name: 'fetchTemplateMostRecent',
    parentDomain: domain,
    result: TemplatePopulated,
    getKey: ['id']
  });
  var InitiatorParam = _Template.InitiatorParam = t.type({
    source: AssigneeSourceIO,
    initiatorId: t.string
  });
  var updateTemplate = _Template.updateTemplate = ApiCallService.create({
    name: 'updateTemplate',
    parentDomain: domain,
    result: TemplatePopulated,
    getKey: ['id', 'version']
  });
  var TemplateShortInfo = t.type({
    templateId: t.number,
    templateVersion: t.number
  });
  var createSection = _Template.createSection = ApiCallService.create({
    name: 'createSection',
    parentDomain: domain,
    result: t.intersection([Section, TemplateShortInfo]),
    getKey: ['templateId', 'templateVersion', 'section']
  });
  var updateSection = _Template.updateSection = ApiCallService.create({
    name: 'updateSection',
    parentDomain: domain,
    result: t.intersection([Section, TemplateShortInfo]),
    getKey: ['templateVersion', 'templateId', 'sectionId', 'section']
  });
  var deleteSection = _Template.deleteSection = ApiCallService.create({
    name: 'deleteSection',
    parentDomain: domain,
    result: t.intersection([Section, TemplateShortInfo]),
    getKey: ['sectionId', 'templateId', 'templateVersion']
  });
  var createQuestion = _Template.createQuestion = ApiCallService.create({
    name: 'createQuestion',
    parentDomain: domain,
    result: t.intersection([Question, TemplateShortInfo]),
    getKey: ['templateVersion', 'templateId', 'sectionId', 'question']
  });
  var updateQuestion = _Template.updateQuestion = ApiCallService.create({
    name: 'updateQuestion',
    parentDomain: domain,
    result: t.intersection([Question, TemplateShortInfo]),
    getKey: ['question', 'questionId', 'sectionId', 'templateId', 'templateVersion']
  });
  var deleteQuestion = _Template.deleteQuestion = ApiCallService.create({
    name: 'deleteQuestion',
    parentDomain: domain,
    result: t.intersection([Question, TemplateShortInfo]),
    getKey: ['templateVersion', 'templateId', 'sectionId', 'questionId']
  });
  var createTemplate = _Template.createTemplate = ApiCallService.create({
    name: 'createTemplate',
    parentDomain: domain,
    result: TemplatePopulated,
    getKey: ['allowSectionAssignee', 'description', 'name', 'signatureRequired', 'templateTypeId', 'projectUrn']
  });
  var deleteTemplate = _Template.deleteTemplate = ApiCallService.create({
    name: 'deleteTemplate',
    parentDomain: domain,
    result: TemplatePopulated,
    getKey: ['id', 'version']
  });
  var fetchTypes = _Template.fetchTypes = ApiCallService.create({
    name: 'fetchTypes',
    parentDomain: domain,
    result: t.array(TemplateType),
    getKey: function getKey() {
      return '0';
    }
  });
})(Template || (Template = {}));